import styled from 'styled-components';

import {stretch} from '../../../libs/shared/ui/src/styles/mixins';

/*
 * Grid.
 */

export const Grid = styled.div`
  display: grid;
  height: 100%;

  grid-auto-columns: 100%;
  grid-auto-rows: 100%;
`;

/*
 * Grid item.
 */

interface GridItemProps {
  column?: number | string;
  row?: number | string;
}

export const GridItem = styled.div<GridItemProps>`
  min-width: 0;
  min-height: 0;
  grid-column: ${(p) => p.column || 1};
  grid-row: ${(p) => p.row || 1};
`;

export const StyledStretchGridItem = styled(GridItem)`
  ${stretch()}
`;

interface GridAreaItemProps {
  area: string;
}
export const GridAreaItem = styled.div<GridAreaItemProps>`
  grid-area: ${(p) => p.area};
`;
